export enum NOTIFICATION_STYLES {
  POPUP = "POPUP",
  SNACKBAR = "SNACKBAR",
}
